<template>
    <v-card outlined class="bordered-card" :class="[{ 'finished': isStatusFinished }]">
<!-- Header -->
        <v-container fluid>
            <v-row align="center" justify="space-between" class="ma-0 flex-nowrap" style="min-height: 32px">
	            <span>
                <v-chip small class="white--text" :color="mainColor">#{{ item.nrPlanejamentoAlojamento }}</v-chip>
</span>
                <span class="status-text">
	                {{ item.cdStatusPlanejamentoAlojamento | formatarStatus(item, statusTypes) }}
                </span>
            </v-row>
        </v-container>
<!-- Content -->
        <v-container>
            <v-card flat tile color="white" :disabled="isStatusFinished">
                <v-container fluid>
                    <v-row>
                        <v-col cols="6" class="py-1">
                            <div class="d-flex flex-column">
                                <span class="info-text">Início</span>
                                <span class="info-value">{{ item.dtInicioAlojamento | formatarData }}</span>
                            </div>
                        </v-col>
                        <v-col cols="6" class="py-1">
                            <div class="d-flex flex-column">
                                <span class="info-text">Término</span>
                                <span class="info-value">{{ item.dtFimAlojamento | formatarData }}</span>
                            </div>
                        </v-col>
                        <v-col cols="6" class="py-1">
                            <div class="d-flex flex-column">
                                <span class="info-text">Animais Disp.</span>
                                <span class="info-value">{{ item.qtDisponiveis || "--" }}</span>
                            </div>
                        </v-col>
                        <v-col cols="6" class="py-1">
                            <div class="d-flex flex-column">
                                <span class="info-text">Alocados</span>
                                <span class="info-value">{{ item.qtAlocados || "--" }}</span>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-container>
<!-- Actions -->
        <v-container fluid>
            <v-row class="ma-0">
                <v-col cols="4" class="py-1">
                    <historico-planejamento-dialog :list-history-stats="listaStatusHistorico" :item="item"
                                                   :status-types="this.statusTypes" />
                </v-col>
                <v-col cols="4" class="py-1">
                    <cancelar-planejamento-dialog :item="item" @confirmed="onCancelConfirmed">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" block outlined class="view-btn" :disabled="isStatusCancelado || isStatusFinished">
                                <v-icon small>fas fa-trash</v-icon>
                            </v-btn>
                        </template>
                    </cancelar-planejamento-dialog>
                </v-col>
                <v-col cols="4" class="py-1">
                    <editar-planejamento-dialog :item="item" @updated="onUpdated">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" block outlined class="view-btn" :disabled="isStatusCancelado || isStatusFinished">
                                <v-icon small>fas fa-edit</v-icon>
                            </v-btn>
                        </template>
                    </editar-planejamento-dialog>
                </v-col>
                <v-col cols="12" class="py-1">
                    <v-btn block outlined @click="onViewClick" class="view-btn" :loading="loading" :disabled="isStatusCancelado || isStatusFinished">
                        Visualizar
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
import moment from "moment"
import HistoricoPlanejamentoDialog from "./HistoricoPlanejamentoDialog"
import CancelarPlanejamentoDialog from "./CancelarPlanejamentoDialog"
import EditarPlanejamentoDialog from "./EditarPlanejamentoDialog"
import { statusRoutes } from "../../resources";
import {cloneDeep} from "lodash/lang";

export default {
    name: "PlanejamentoAlojamentoCard",
    props: {
        item: {
            type: Object,
            required: true,
        },
        statusTypes: {
            type: Array
        }
    },
    components: {
        EditarPlanejamentoDialog,
        CancelarPlanejamentoDialog,
        HistoricoPlanejamentoDialog,
    },
    data: () => ({
        loading: false,
        listaStatusHistorico: []
    }),
    filters: {
        formatarData(value) {
            if (!value) return ""
            return moment(value).format("DD/MM")
        },
        formatarStatus(value, item, statusTypes) {
            if (!statusTypes) return
            const dtFimAlojamento = moment(item.dtFimAlojamento)
            if (moment(moment.now()).isAfter(dtFimAlojamento.add(1, "day"))) {
                return "Finalizado"
            }
            //TODO Verificar essa questão do checklist Preenchido
            // if (value === 5 && !item.blChecklistPreenchidos) {
            //     return "Turnos parcialmente confirmados"
            // }

            const status = statusTypes.find(type => type.idStatusPlanejamentoAlojamento === value)
            if (!status) return ""
            return status.nmStatus
        },
    },
    methods: {
        onViewClick() {
        	// Por nmStatus
          // this.loading = true
          // let etapa = this.$options.filters.formatarStatus(this.item.cdStatusPlanejamentoAlojamento, this.item, this.statusTypes);
          // etapa = _.camelCase(etapa);
					//
          // this.$router.push(`planejamentoAlojamento/${this.item.idPlanejamentoAlojamento}/${etapa}`)

	      //  Por id
	        this.loading = true
          this.$router.push(`planejamentoAlojamento/${this.item.idPlanejamentoAlojamento}/${statusRoutes[this.item.cdStatusPlanejamentoAlojamento]}`)
        },
        onCancelConfirmed() {
            this.$axios.post('/planejamento-alojamento-status/cancelar-planejamento/' +
                this.item.idPlanejamentoAlojamento + '/', { dsObservacao: "" })
                .then(res => {
                    if(!res.data) return
                    if(!res.data[0].data) return

                    this.$emit("deleted", res.data[0].data)
                })
                .catch((err) => {
                    this.$store.commit("setSnack", {
                        type: "error",
                        msg: err
                })
            })
        },
        onUpdated(planejamentoAlojamento) {
            const item = cloneDeep(this.item)

            item.dtInicioAlojamento = planejamentoAlojamento.dtInicioAlojamento
            item.dtFimAlojamento = planejamentoAlojamento.dtFimAlojamento
            this.$emit("updated", item)
        },
    },
    computed: {
        isStatusFinished() {
            const dtFimAlojamento = moment(this.item.dtFimAlojamento)
            return moment(moment.now()).isAfter(dtFimAlojamento.add(1, "day"))
        },
        isStatusCancelado() {
            const itemStatus = this.statusTypes.find(
                status => status['idStatusPlanejamentoAlojamento'] === this.item.cdStatusPlanejamentoAlojamento
            )

            if (itemStatus) return itemStatus['nmStatus'] === 'Cancelado'
            return false
        },
        mainColor() {
            if(this.isStatusFinished) return "#BDCCCA"
            if(this.isStatusCancelado) return "#fd6b6b"
            return "#2bc1b6"
        },
    },
}
</script>
<style scoped lang="scss">
.bordered-card {
  border: 1px solid #e5e8e7;
  border-radius: 8px;

  &:not(.finished) {
    background: #f2f5f3 0 0 no-repeat padding-box;
  }
}

.view-btn {
  border: 1px solid #e5e8e7;
  border-radius: 4px;
  color: #10303d;
  width: 100%;
}

.status-text {
  text-align: right;
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0;
  color: #37565c;
  opacity: 1;
}

.info-text {
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: #7b9596;
  opacity: 1;
}

.info-value {
  font: normal normal bold 20px/32px Roboto;
  letter-spacing: 0;
  color: #37565c;
  opacity: 1;
}
</style>